import { mountComponentTag } from '@/mounter'

import DotcomIframe from './Iframe'

mountComponentTag('iframe', DotcomIframe)
